import { ErrorType } from '../../../models/HttpError';
import { AppState } from '../../../redux/reducers';
import { ExternalEntityAssociationViewModel } from '../../../models/Entities/Person/ExternalAssociation/ExternalAssociationModels';

// store
import * as PersonExternalAssociationsStore from '../../../redux/middleware/PersonExternalAssociations.Middleware';

export interface IProps {
  PersonId: number;
}

interface ConnectedProps {
  isLoading: boolean | undefined;
  isLoadingSuccessfully: boolean | undefined;
  failOnLoading: boolean | undefined;
  isDeleting: boolean | undefined;
  failOnDeleting: boolean | undefined;
  error: ErrorType | undefined;
  externalAssociations: ExternalEntityAssociationViewModel[];
}

interface DispatchProps {
  GetExternalAssociationsByPersonId: typeof PersonExternalAssociationsStore.actionCreators.GetExternalAssociationsByPersonId;
  DeleteExternalAssociation: typeof PersonExternalAssociationsStore.actionCreators.DeleteExternalAssociation;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
  isLoading: state.PersonExternalAssociations?.isLoadingAll,
  isLoadingSuccessfully: state.PersonExternalAssociations?.successLoadingAll,
  failOnLoading: state.PersonExternalAssociations?.failOnLoadingAll,
  isDeleting: state.PersonExternalAssociations?.isDeletingOne,
  failOnDeleting: state.PersonExternalAssociations?.failOnDeletingOne,
  error: state.PersonExternalAssociations?.error,
  externalAssociations: (state.PersonExternalAssociations?.list ?? []).filter(
    (item: ExternalEntityAssociationViewModel) => item.personId === ownProps.PersonId
  ),
  ...ownProps
});

export const mapDispatchToProps = {
  ...PersonExternalAssociationsStore.actionCreators
};
